import { render, staticRenderFns } from "./GoalList.vue?vue&type=template&id=7eda1ccd"
import script from "./GoalList.vue?vue&type=script&lang=js"
export * from "./GoalList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports